import request from 'sb-request'
import actions from 'redux/actions'
import { getState, reducers } from 'redux/core'
import { mixpanel, constants, links, getPrefixedAddressFields } from 'common/helpers'

import {
  setupBegin, setupCommit, setupBeginPayPal, setupCommitPayPal, callVindicia,
  syncUserAndSubscription, setupBeginApplePay, setupCommitApplePay,
  callAnalytics,
} from './util'


/**
 *
 * @param {object} values
 * @param {object} values.shipping
 * @param {object} values.billing
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const begin = (values) => {
  // const error = checkRequiredFields(Object.keys(values), [
  //   'shippingFirstName',
  //   'shippingLastName',
  //   'shippingStreet',
  //   'shippingApt',
  //   'shippingZipCode',
  //   'shippingState',
  //   'shippingCity',
  //   'billingFirstName',
  //   'billingLastName',
  //   'billingStreet',
  //   'billingApt',
  //   'billingZipCode',
  //   'billingState',
  //   'billingCity',
  //   'paymentType',
  //   'token',
  // ])
  //
  // if (error) {
  //   return Promise.reject(error)
  // }

  const {
    view: { paymentPage: { useCredits } },
    models: { requestTokens: { order: orderToken } },
  } = getState()

  const { shipping, billing, paymentMethod } = values

  const body = {
    ...getPrefixedAddressFields({ shipping, billing }),
    paymentType: paymentMethod, // TODO ask backend rename `paymentType` to `paymentMethod`
    ignoreCredits: !useCredits,
    token: orderToken,
  }

  const begin = setupBegin({
    endpoint: 'rest/order/begin',
    tokenName: constants.requestTokens.order,
  })

  return begin(body)
}

const commit = (values) => {
  const { view: { paymentPage: { useCredits } } } = getState()

  const body = {
    ...values,
    ignoreCredits: !useCredits,
  }

  const commit = setupCommit({
    endpoint: 'rest/order/commit',
    tokenName: constants.requestTokens.order,
  })

  return commit(body)
}

/**
 *
 * @param {object} values
 * @param {object} values.shipping
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @param {bool}   values.isEnoughCreditsToBuy
 */
const buyOrder = (values) => {
  const { shipping, billing, creditCard, paymentType, isEnoughCreditsToBuy } = values

  mixpanel.track(constants.analyticsEvents.tech.buyOrder)

  return begin(values)
    .then(
      (data) => {
        const body = {
          paymentType,
          shipping,
          billing,
          creditCard,
          ...data,
        }

        if (isEnoughCreditsToBuy) {
          return Promise.resolve(data)
        }

        return callVindicia(body)
      },
      (err) => Promise.reject(err)
    )
    .then(
      ({ orderSession, token }) => commit({ orderSession, token }),
      (err) => Promise.reject(err)
    )
    .then(
      (result) => {
        syncUserAndSubscription({ paymentType, ...result })
        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: true,
        })
      },
      (err) => {
        const { title, message, resData: { isCvvError, authCode } = {} } = err

        const isBillingError = authCode === '713'

        actions.view.paymentPage.setBillingError(isBillingError)

        if (isCvvError) {
          actions.models.modals.open(constants.modals.ErrorCVV)
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            title,
            content: message,
          })
        }

        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: false,
          reason: `${authCode} | ${title} | ${message}`,
        })

        return Promise.reject(err)
      }
    )
    .then(() => {
      actions.view.paymentPage.setBillingError(false)
      callAnalytics()
      actions.models.router.push(links.thankYou)
      actions.models.cart.clear()
    })
}


// PayPal

const beginPaymentUsingPayPal = (values) => {
  const beginPayPal = setupBeginPayPal({
    begin,
    sessionName: 'orderSession',
  })

  return beginPayPal(values)
}

/**
 *
 * @param values
 * @param {string} values.paymentType
 * @param {string} values.paypalSessionId
 */
const commitPaymentUsingPayPal = (values) => {
  const commitPayPal = setupCommitPayPal({
    commit,
    sessionName: 'orderSession',
  })

  return commitPayPal(values)
    .then(
      () => {
        callAnalytics()
        actions.models.router.push(links.thankYou)
        actions.models.cart.clear()
      },
      (err) => Promise.reject(err)
    )
}


// ApplePay

const beginPaymentUsingApplePay = (values) => {
  const begin = setupBegin({
    endpoint: 'rest/order/begin',
    tokenName: constants.requestTokens.order,
  })

  const beginApplePay = setupBeginApplePay({
    begin,
    tokenName: constants.requestTokens.order,
    sessionName: 'orderSession',
  })

  return beginApplePay(values)
}

const commitPaymentUsingApplePay = (session, values) => {
  const commitApplePay = setupCommitApplePay({
    commit,
    session,
    sessionName: 'orderSession',
    paymentType: constants.paymentTypes.ecommerce,
    tokenName: constants.requestTokens.order,
  })

  return commitApplePay(values)
    .then(
      () => {
        callAnalytics()
        actions.models.router.push(links.thankYou)
        actions.models.cart.clear()
      },
      (err) => Promise.reject(err)
    )
}


// Buy In One Click
// you can buy the cart in one click

const fetchCanBuyInOneClickStatus = () =>
  request.get('rest/order/cart/fast')
    .then(({ canBuyInOneClick } = {}) => {
      reducers.models.payment.setCanBuyInOneClickStatus(canBuyInOneClick)
    })

const buyOrderInOneClick = () => {
  const { models: { requestTokens: { order: token } } } = getState()

  return request.post('rest/order/cart/fast', {
    body: {
      token,
    },
  })
    .then((result) => syncUserAndSubscription({
      paymentType: constants.paymentTypes.ecommerce,
      ...result,
    }))
    .then(
      () => {
        actions.models.cart.clear()
        callAnalytics()
        actions.models.router.push(links.thankYou)
        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: true,
        })
      },
      (err) => {
        const { title, message, resData: { isCvvError, authCode } = {} } = err

        if (isCvvError) {
          actions.models.modals.open(constants.modals.ErrorCVV)
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            title,
            content: message,
          })
        }

        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: false,
          reason: `${authCode} | ${title} | ${message}`,
        })

        return Promise.reject(err)
      },
    )
}


export {
  buyOrder,
  beginPaymentUsingPayPal,
  commitPaymentUsingPayPal,
  beginPaymentUsingApplePay,
  commitPaymentUsingApplePay,
  fetchCanBuyInOneClickStatus,
  buyOrderInOneClick,
}
